import { RootState } from "@/redux/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IHotelRecheckRoomOption,
  IHotelRoomPricing,
  IRateComments,
} from "../types/hotel-room-list.type";

export const MAX_HOTEL_COMPARE_ITEMS = 3;

export interface IHotelCompare {
  id?: string | number;
  hotelCode?: string | number;
  hotelName?: string;
  address?: string;
  boarding_details?: string[];
  currency?: string;
  no_of_rooms?: number;
  other_inclusions?: string[];
  rate_comments?: IRateComments;
  rooms?: IHotelRecheckRoomOption[];
  supports_amendment?: boolean;
  supports_cancellation?: boolean;
  refundable?: boolean;
  price_details?: IHotelRoomPricing;
}

interface UnifiedHotelFilterState {
  hotelCompare: IHotelCompare[];
}

const initialState: UnifiedHotelFilterState = {
  hotelCompare: [],
};

const hotelCompareSlice = createSlice({
  name: "hotel_data_slice",
  initialState,
  reducers: {
    addHotelCompareList: (state, action: PayloadAction<IHotelCompare>) => {
      const exists = state.hotelCompare.find((h) => h.id === action.payload.id);
      if (!exists) {
        state.hotelCompare.push(action.payload);
      }
    },
    removeHotelFromCompare: (state, action: PayloadAction<string | number>) => {
      state.hotelCompare = state.hotelCompare.filter(
        (hotel) => hotel.id !== action.payload,
      );
    },
    clearHotelCompare: (state) => {
      state.hotelCompare = [];
    },
  },
});

export const useSelectedHotelCompare = (state: RootState) =>
  state.hotelCompareAndQuotation.hotelCompare;

export const {
  addHotelCompareList,
  removeHotelFromCompare,
  clearHotelCompare,
} = hotelCompareSlice.actions;

export default hotelCompareSlice;
